import _ from 'lodash';

import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { Subject, Observable } from 'rxjs';

export class DRLCClientPlugin extends SmartenitPlugin {
  public static EXPIRED_STATE = 0;
  public static ACTIVE_STATE = 1;
  public static OPT_OUT_STATE = 2;
  public static OPT_IN_STATE = 3;
  public static OPT_IN = 0;
  public static OPT_OUT = 1;

  private _optedIn: boolean = false;
  private _onDRLCEvent: Subject<any> = new Subject<any>();

  get onDRLCEvent(): Observable<any> | undefined {
    return this._onDRLCEvent.asObservable();
  }

  public getReportableAttrs() {
    return ['Participation', 'EventStatus'];
  }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number) {
    const attributeOrMethod = message && message.attributeOrMethod;
    const supportedMethods = [
      'ReportEventStatus',
      'GetScheduledEvents',
    ];

    const suportedAttributes = [
      'UtilityEnrollmentGroup',
      'StartRandomizeMinutes',
      'StopRandomizeMinutes',
      'DeviceClassValue',
      'Participation',
      'EventStatus'
    ];

    if (attributeOrMethod && (supportedMethods.indexOf(attributeOrMethod) > -1 || suportedAttributes.indexOf(attributeOrMethod) > -1)) {
      // TODO handle received methods or attributes
      if (attributeOrMethod == 'Participation') {
        const response = message && message.data && message.data.response;
        this._optedIn = response.value === DRLCClientPlugin.OPT_IN;
        this._onUpdate.next({ _optedIn: this._optedIn });
      }

      if (attributeOrMethod == 'EventStatus') {
        const response = message && message.data && message.data.response;
        this._onUpdate.next({ state: response.value });
        this._onDRLCEvent.next({ drlcState: response.value === DRLCClientPlugin.OPT_IN_STATE });
      }
    }

    return this.state;
  }

  public triggerDRLCEvent(eventState: number) {
    this._onUpdate.next({ state: eventState });
    this._onDRLCEvent.next({ drlcState: eventState === DRLCClientPlugin.OPT_IN_STATE });
  }

  public setMFGParticipation(participation: boolean) {
    this._optedIn = participation;
    const params = { value: participation ? DRLCClientPlugin.OPT_IN : DRLCClientPlugin.OPT_OUT };
    this.device
      .setAttribute(this.componentId, this.processorName, 'Participation', params, false)
      .subscribe();
    this._onUpdate.next({ _optedIn: this._optedIn });
  }

  public hasOptedIn() {
    return this._optedIn;
  }
}
